import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
export function LandingPage() {
  return <main className="min-h-screen bg-cream flex flex-col w-full overflow-x-hidden" data-id="element-137">
      <UrgencyBar data-id="element-138" />
      <HeroSection data-id="element-139" />
      <HookSection data-id="element-140" />
      <PainSection data-id="element-141" />
      <RevelationSection data-id="element-142" />

      <ValueStack data-id="element-143" />
      <PricingSection data-id="element-144" />
      <FAQSection data-id="element-145" />
      <GuaranteeSection data-id="element-146" />
      <ClosingSection data-id="element-147" />
    </main>;
}